export default "__VITE_ASSET__BLqCK7AN__"